import { FileUp, FileX, ExternalLink } from "lucide-react";
import { Anexo } from "../../../types";
import toastservice from "../../../../../../../../../services/toast";

const FileXCorner = ({ size = 24, color = "currentColor" }: { size?: number; color?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5"/>
        <path d="M14 2v5a1 1 0 0 0 1 1h5"/>
        <path d="m15 17 5 5"/>
        <path d="m20 17-5 5"/>
    </svg>
);

interface CardAnexoProps {
    anexo: Anexo;
    onNavigateToFile?: (fileId: number) => void;
}

export default function CardAnexo({ anexo, onNavigateToFile }: CardAnexoProps) {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (anexo.excluido) {
            toastservice.error('Este arquivo foi removido e não está mais disponível.');
            return;
        }
        if (onNavigateToFile && anexo.id) {
            onNavigateToFile(anexo.id);
        }
    };

    const formatarData = (data?: string) => {
        if (!data) return '';
        try {
            const date = new Date(data);
            return new Intl.DateTimeFormat('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(date);
        } catch {
            return data;
        }
    };

    const podeClicar = anexo.id && onNavigateToFile && !anexo.excluido;

    return (
        <div 
            className="anexo-item" 
            data-excluido={anexo.excluido ? "true" : "false"}
            style={{ 
                opacity: anexo.excluido ? 0.75 : 1,
                cursor: podeClicar ? 'pointer' : 'default',
                border: anexo.excluido ? '1px solid rgba(239, 68, 68, 0.3)' : undefined
            }}
            onClick={podeClicar ? handleClick : undefined}
        >
            {anexo.excluido ? (
                <div className="anexo-icon">
                    <FileXCorner size={16} color="#EF4444" />
                </div>
            ) : (
                <FileUp className="anexo-icon" />
            )}
            <div className="anexo-info">
                <p className="anexo-filename">{anexo.filename}</p>
                <p className="anexo-size">{anexo.size}</p>
            </div>
            {anexo.excluido ? (
                <div style={{
                    padding: '2px 8px',
                    borderRadius: '12px',
                    border: '1px solid rgba(239, 68, 68, 0.3)',
                    fontSize: '10px',
                    fontWeight: 500,
                    color: 'var(--cef4444)',
                    whiteSpace: 'nowrap'
                }}>
                    Removido
                </div>
            ) : (
                podeClicar && (
                    <ExternalLink className="anexo-link" size={14} />
                )
            )}
        </div>
    );
}

